import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

//Prime React Components
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';

//Custom Validation
import { LoginValidate } from '../../config/Validate';

//Buffer Storage
import { Buffer } from 'buffer';

//API Constant Settings
import { LOGIN } from '../../config/ApiConstant';
import axiosInstance from '../../config/axiosInstance';

interface finalObj {
    mobile: any;
    password: any;
}

export const Login = () => {
    document.title = 'Login | Karan Enterprise';
    const [loginData, setLoginData] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const toast = useRef<any>(null);

    const navigate = useNavigate();

    // handle Change
    const _onHandleChange = (e: any, name: string) => {
        const val = (e.target && e.target.value) || '';
        setLoginData({ ...loginData, [name]: val });
    };

    //on submit button event
    const onSubmit = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        event.stopPropagation();

        try {
            const { errors, isError } = LoginValidate(loginData);
            setErrors(errors);

            if (!isError) {
                setButtonLoading(true);
                const mobile = loginData.mobile;
                //Password base64 convert
                let passwordBuff = Buffer.from(loginData.password).toString('base64');

                //Create Request Data Object
                const Obj: finalObj = {
                    mobile: mobile,
                    password: passwordBuff
                };

                //API Call
                const response = await axiosInstance.post(LOGIN, Obj);

                //Get API Response

                if (response) {
                    // get Data for localstorage
                    const { token, user_data } = response.data;

                    //After Success Login Set Token in Common
                    axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                    //set localstorage
                    localStorage.setItem('token', token);
                    localStorage.setItem('id', user_data?.id);
                    localStorage.setItem('full_name', user_data?.first_name + ' ' + user_data?.last_name);
                    localStorage.setItem('user_type', user_data?.user_type);

                    toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Login Successful' });
                    setButtonLoading(false);
                    navigate('/dashboard');
                }
            }
        } catch (error: any) {
            setButtonLoading(false);
            toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error });
        }
    };

    return (
        <div className="login-body">
            <div className="login-panel p-fluid">
                <Toast ref={toast} />
                <div>
                    <div className="logo-container">
                        <img src="/assets/images/logo.png" className="login-logo" alt="login-logo" />
                    </div>

                    <div>
                        <div className="field">
                            <InputText
                                value={!window.cn(loginData.mobile) ? loginData?.mobile : ''}
                                name="mobile"
                                type="number"
                                autoComplete="off"
                                placeholder="Enter Mobile No."
                                onChange={(e) => _onHandleChange(e, 'mobile')}
                                className={errors['mobile'] && 'p-invalid'}
                            />
                            <small className="p-invalid-txt d-flex">{errors['mobile']}</small>
                        </div>
                        <div className="field">
                            <Password
                                value={loginData.password}
                                name="password"
                                placeholder="Enter Password"
                                onChange={(e) => _onHandleChange(e, 'password')}
                                feedback={false}
                                toggleMask
                                autoComplete="off"
                                className={errors['password'] && 'p-invalid'}
                            />
                            <small className="p-invalid-txt d-flex">{errors['password']}</small>
                        </div>
                        <div className="button-container">
                            <Button type="button" label="Login" loading={buttonLoading} onClick={onSubmit}></Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
